import type React from 'react';
import { Button } from './Button.js';
import { Modal } from './Modal.js';

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  /** What will happen, in the user's words: "Delete the template 'Researcher'? Workflows using it stop working." */
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** `danger` for deletes and other changes that cannot be undone. */
  tone?: 'danger' | 'primary';
  /** The confirm action is running: the buttons lock and the dialog stays open. */
  loading?: boolean;
}

/**
 * Asks before an irreversible or costly action. The confirm button names the action ("Delete template"), never
 * just "OK", and Cancel is always the safe default.
 */
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'danger',
  loading = false,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="md"
      dismissable={!loading}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={tone} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="text-sm text-text-100">{message}</div>
    </Modal>
  );
}
